<div class="box">
  <div>
    <h1>
      Ops...
    </h1>
    <p>
      Página não encontrada.<br>
      <span style="font-size: 14px;">
        Ou esta é uma área restrita
      </span>
    </p>
  </div>
</div>

<style>
  .box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div {
    text-align: center;
  }
  h1 {
    font-size: 36px;
    margin-top: -100px;
  }
  p {
    font-size: 21px;
  }
</style>